module.exports = __webpack_public_path__ + "img/wd_grey.c38771d6.png";